module.exports = __webpack_public_path__ + "static/media/A6-landscape-v3.4d2cedfd.svg";